/**
 * Initializes the lazy background image loader by dynamically importing the necessary module.
 * If the lazy background image element is not found, the function exits early.
 *
 * @throws Will throw an error if the lazy background image loader fails to initialize.
 */
export const initializeLazyBgImageLoader = async (): Promise<void> => {
  const lazyBgElement = document.querySelector<HTMLElement>('[data-lazy-bg]');

  if (!lazyBgElement) return; // Exit if the lazy background image element is not found

  try {
    const { lazyBgImageLoader } = await import(
      '@ms/shared/utils/loaders/lazy-bg-image-loader'
    );

    lazyBgImageLoader.init();
  } catch (error: unknown) {
    // eslint-disable-next-line no-console
    console.error('🚨 Error initializing lazy background image loader:', error);

    throw new Error(
      `Failed to initialize lazy background image loader: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  }
};
